import React from "react";

export const PageNotFound = () => {
    return (
        <div className="container-fluid w-100 d-flex justify-content-center align-items-center font-weight-bolder"
            style={{fontSize: "6rem", color: "#d3d3d3", height: "80vh"}}>PAGE NOT FOUND</div>
    )
}